import * as React from 'react'
import { styled, FontWeight } from '$utils/theme'
import { rem } from 'polished'

interface Props extends React.InputHTMLAttributes<any> {
  className?: string
  label?: string
  isChecked?: (name: string) => boolean
  mini?: boolean
}

export const MultipleCheckboxWrapper = styled.div.attrs({})<Props>`
  display: flex;
  background-color: ${p => p.theme.colors.xlightGrey};
  border: solid 1px ${p => p.theme.colors.lightGrey};
  border-radius: ${rem(5)};
  height: ${rem(48)};
  ${p =>
    p.mini &&
    `
      height: ${rem(32)};
  `};
`

const MultipleCheckboxLabel = styled.label.attrs({})<Props>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: ${rem(48)};
  justify-content: center;
  color: ${p => p.theme.colors.menu};
  &:nth-child(1) span::after {
    border-top-left-radius: ${rem(5)};
    border-bottom-left-radius: ${rem(5)};
    border-right: solid 2px ${p => p.theme.colors.lightGrey};
  }
  &:nth-last-child(1) span::after {
    border-top-right-radius: ${rem(5)};
    border-bottom-right-radius: ${rem(5)};
    border-left: solid 2px ${p => p.theme.colors.lightGrey};
  }
`

const StyledCheckbox = styled.span`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  height: ${rem(48)};
`
const MultipleCheckboxInput = styled.input.attrs({})<Props>`
  opacity: 0;

  &:focus {
    outline: none;
  }
  ~ ${StyledCheckbox} {
    &::after {
      display: flex;
      content: '${p => p.label}';
      align-items: center;
      justify-content: center;
      position: absolute;
      height: ${rem(48)};
      cursor: pointer;
      ${p =>
        p.mini &&
        `
        height: ${rem(32)};
        cursor: default;
      `}
      width: 100%;

    }
  }

  &:checked ~ ${StyledCheckbox} {
    &::after {
      background: ${p => p.theme.colors.darkGrey};
      color: white;
      border-color: ${p => p.theme.colors.white};
      font-weight: ${FontWeight.medium};
    }
  }
`
export const MultipleCheckbox: React.SFC<Props> = ({ label, name, onBlur, isChecked, id, mini, ...props }) => {
  return (
    <MultipleCheckboxLabel htmlFor={id} mini={mini} {...props}>
      <MultipleCheckboxInput
        name={name}
        type="checkbox"
        onBlur={onBlur}
        defaultChecked={isChecked(name)}
        mini={mini}
        {...{ id, label, ...props }}
      />
      <StyledCheckbox />
    </MultipleCheckboxLabel>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Checkbox/CheckboxMultiple.tsx